<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { useBranding } from 'shared/composables/useBranding';
// import { differenceInDays } from 'date-fns';

export default {
  components: { Banner },
  setup() {
    const { accountId } = useAccount();
    const { replaceInstallationName } = useBranding();
    return {
      accountId,
      replaceInstallationName,
    };
  },
  data() {
    return { conversationMeta: {} };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
    }),
    actionButtonMessage() {
      return this.$t('GENERAL_SETTINGS.OPEN_BILLING');
    },
    shouldShowBanner() {
      if (this.isTrialAccount()) {
        return false;
      }

      return this.isLimitExceeded();
    },
  },
  mounted() {
    this.fetchLimits();
  },
  methods: {
    fetchLimits() {
      this.$store.dispatch('accounts/limits');
    },
    routeToBilling() {
      this.$router.push({
        name: 'wgpt_billing_settings_index',
        params: { accountId: this.accountId },
      });
    },
    isTrialAccount() {
      // check if account is less than 15 days old
      // const account = this.getAccount(this.accountId);
      // if (!account) return false;

      // const createdAt = new Date(account.created_at);

      // const diffDays = differenceInDays(new Date(), createdAt);

      // return diffDays <= 15;
      return false;
    },
    isLimitExceeded() {
      const account = this.getAccount(this.accountId);
      if (!account) return false;

      const { limits } = account;
      if (!limits) return false;

      // const { conversation, non_web_inboxes: nonWebInboxes } = limits;
      // return this.testLimit(conversation) || this.testLimit(nonWebInboxes);

      const keysExceedLimit = Object.keys(limits).filter(key =>
        this.testLimit(limits[key])
      );
      return keysExceedLimit.length > 0;
    },
    testLimit({ allowed, consumed }) {
      return consumed > allowed;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="
      replaceInstallationName($t('GENERAL_SETTINGS.LIMITS_UPGRADE'))
    "
    :action-button-label="actionButtonMessage"
    has-action-button
    @primary-action="routeToBilling"
  />
</template>
